<template>
  <!--====== NAVBAR ONE PART START ======-->

  <nav class="navbar navbar-expand-lg fixed-top" :class="navbarClass">
    <div class="container navbar-container">
      <a class="navbar-brand" @click="goToHome()">
        <img src="../assets/logo.png" width="90" alt="Logo" />
      </a>

      <p class="btn-bars d-none" @click="openSidebar">
        <i class="fa-solid fa-bars"></i>
      </p>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link to="/">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/services">Services</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/works">Portfolio</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/about">About</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/jobs">Jobs</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/contact">Contact</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div
    class="offcanvas offcanvas-start"
    tabindex="-1"
    id="offcanvasExample"
    aria-labelledby="offcanvasExampleLabel"
  >
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasExampleLabel">
        <a @click="goToHome()">
          <img src="../assets/logo_color.png" alt="Logo" width="60" />
        </a>
      </h5>
      <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      >
        X
      </button>
    </div>
    <div class="offcanvas-body">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item">
          <a @click="goToHome()">Home</a>
        </li>
        <li class="nav-item">
          <router-link to="/services">Services</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/works">Works</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/about">About</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/jobs">Jobs</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/contact">Contact</router-link>
        </li>
      </ul>
    </div>
  </div>

  <transition name="backdrop-fade">
    <div
      v-if="isActive"
      class="sidebar-backdrop"
      @click="closeSidebar()"
    ></div>
  </transition>

  <aside
    class="sidebar"
    :class="{ 'is-active': isActive }"
    aria-label="Mobile navigation"
    :aria-hidden="!isActive"
  >
    <div class="sidebar-header">
      <a class="sidebar-logo" @click="goToHome()">
        <img src="../assets/logo.png" alt="Multimedia Agency" />
      </a>
      <button
        type="button"
        class="sidebar-close"
        @click="closeSidebar()"
        aria-label="Close menu"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <nav class="sidebar-nav">
      <ul>
        <li>
          <a class="sidebar-link" @click="goToHome()">
            <span class="link-dot"></span>
            <span>Home</span>
          </a>
        </li>
        <li>
          <router-link to="/services" class="sidebar-link">
            <span class="link-dot"></span>
            <span>Services</span>
          </router-link>
        </li>
        <li>
          <router-link to="/works" class="sidebar-link">
            <span class="link-dot"></span>
            <span>Portfolio</span>
          </router-link>
        </li>
        <li>
          <router-link to="/about" class="sidebar-link">
            <span class="link-dot"></span>
            <span>About</span>
          </router-link>
        </li>
        <li>
          <router-link to="/jobs" class="sidebar-link">
            <span class="link-dot"></span>
            <span>Jobs</span>
          </router-link>
        </li>
        <li>
          <router-link to="/contact" class="sidebar-link">
            <span class="link-dot"></span>
            <span>Contact</span>
          </router-link>
        </li>
      </ul>
    </nav>

    <div class="sidebar-footer">
      <p class="sidebar-footer-label">Follow us</p>
      <div class="sidebar-social">
        <a
          href="https://www.facebook.com/multimediaagencyiraq"
          target="_blank"
          rel="noopener"
          aria-label="Facebook"
        >
          <i class="fa-brands fa-facebook-f"></i>
        </a>
        <a
          href="https://www.instagram.com/multimedia_agency/"
          target="_blank"
          rel="noopener"
          aria-label="Instagram"
        >
          <i class="fa-brands fa-instagram"></i>
        </a>
        <a
          href="https://www.linkedin.com/company/ma-interact/"
          target="_blank"
          rel="noopener"
          aria-label="LinkedIn"
        >
          <i class="fa-brands fa-linkedin-in"></i>
        </a>
      </div>
    </div>
  </aside>

  <!--====== NAVBAR ONE PART ENDS ======-->

  <!--====== Bootstrap js ======-->
</template>

<script>
export default {
  data() {
    return {
      scrollPosition: 0,
      isActive: false,
    };
  },
  methods: {
    openSidebar() {
      this.isActive = true;
    },
    closeSidebar() {
      this.isActive = false;
    },

    goToHome() {
      this.isActive = false;
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
    navigateToPage(name) {
      this.isActive = false;
      this.$router.push("/" + name);
    },
    updateScroll() {
      this.scrollPosition =
        window.scrollY || document.documentElement.scrollTop;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.updateScroll);
  },

  computed: {
    navbarClass() {
      return this.scrollPosition > 730 ? "navbar-bg" : "";
    },
  },

  watch: {
    $route() {
      this.isActive = false;
    },
    isActive(open) {
      document.body.style.overflow = open ? "hidden" : "";
    },
  },
};
</script>

<style scoped>
/* ============ SIDEBAR BACKDROP ============ */
.sidebar-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(5, 4, 24, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 9999998;
}

.backdrop-fade-enter-active,
.backdrop-fade-leave-active {
  transition: opacity 0.3s ease;
}

.backdrop-fade-enter-from,
.backdrop-fade-leave-to {
  opacity: 0;
}

/* ============ SIDEBAR ============ */
.sidebar {
  width: 300px;
  max-width: 86vw;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background: rgba(10, 8, 45, 0.92);
  backdrop-filter: blur(24px) saturate(140%);
  -webkit-backdrop-filter: blur(24px) saturate(140%);
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 24px 0 60px rgba(0, 0, 0, 0.4);
  transform: translateX(-100%);
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 9999999 !important;
  overflow-y: auto;
}

.sidebar::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background: linear-gradient(
    180deg,
    transparent,
    rgba(85, 181, 236, 0.4),
    rgba(98, 33, 126, 0.4),
    transparent
  );
}

.sidebar.is-active {
  transform: translateX(0);
}

.btn-bars {
  font-size: 17px !important;
  color: white !important;
}

/* ============ SIDEBAR HEADER ============ */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.sidebar-logo {
  display: inline-block;
  cursor: pointer;
}

.sidebar-logo img {
  width: 72px;
  height: auto;
  display: block;
}

.sidebar-close {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #ffffff;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease,
    transform 0.25s ease;
}

.sidebar-close:hover {
  background: linear-gradient(135deg, #55b5ec 0%, #62217e 100%);
  border-color: transparent;
  transform: rotate(90deg);
}

/* ============ SIDEBAR NAV ============ */
.sidebar-nav {
  flex: 1;
  padding: 24px 16px;
  margin: 0 !important;
}

.sidebar-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  border-radius: 12px;
  color: #b9c3d1;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  font-family: Poppins-Regular, sans-serif;
  cursor: pointer;
  position: relative;
  transition: color 0.2s ease, background 0.2s ease, transform 0.2s ease;
}

.link-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  flex-shrink: 0;
}

.sidebar-link:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.04);
  transform: translateX(4px);
}

.sidebar-link:hover .link-dot {
  background: linear-gradient(135deg, #55b5ec, #62217e);
  transform: scale(1.4);
  box-shadow: 0 0 12px rgba(85, 181, 236, 0.6);
}

.sidebar-link.router-link-active {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.06);
}

.sidebar-link.router-link-active .link-dot {
  background: linear-gradient(135deg, #55b5ec, #62217e);
  transform: scale(1.4);
  box-shadow: 0 0 12px rgba(85, 181, 236, 0.6);
}

/* ============ SIDEBAR FOOTER ============ */
.sidebar-footer {
  padding: 20px 24px 28px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.sidebar-footer-label {
  margin: 0 0 12px;
  font-size: 11px;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #8b91b8;
}

.sidebar-social {
  display: flex;
  gap: 10px;
}

.sidebar-social a {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #ffffff;
  font-size: 14px;
  text-decoration: none;
  transition: transform 0.2s ease, background 0.2s ease,
    border-color 0.2s ease;
}

.sidebar-social a:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, #55b5ec 0%, #62217e 100%);
  border-color: transparent;
}

.navbar-nav .nav-item {
  background: white !important;
  padding: 10px 20px !important;
  border-radius: 20px !important;
  margin: 0px 8px !important;
  font-size: 17px !important;
  cursor: pointer !important;
  transition: background 0.25s ease, box-shadow 0.25s ease,
    transform 0.25s ease;
}

.navbar-nav .nav-item a {
  color: #490e74 !important;
  text-transform: uppercase !important;
  font-family: Poppins-Regular !important;
  transition: color 0.25s ease;
}

.navbar-nav .nav-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(255, 255, 255, 0.18);
}

.navbar-nav .nav-item:has(a.router-link-active) {
  background: linear-gradient(135deg, #55b5ec 0%, #62217e 100%) !important;
  box-shadow: 0 8px 22px rgba(98, 33, 126, 0.45);
}

.navbar-nav .nav-item a.router-link-active {
  color: #ffffff !important;
}

.navbar {
  background: transparent !important;
}

.navbar-bg {
  background: #0a082d !important;
}

@media (max-width: 767px) {
  .navbar-brand img {
    width: 50px !important;
  }
}

@media only screen and (max-width: 999px) {
  .navbar-container {
    padding: 7px 16px !important;
  }

  .btn-bars {
    display: block !important;
  }
}

.two-item {
  background: white !important;
  border-radius: 20px !important;
}

.offcanvas {
  background: #0a082d !important;
}

.offcanvas .navbar-nav .nav-item {
  background: #0a082d !important;
  color: white !important;
}

.offcanvas .navbar-nav .nav-item a {
  color: white !important;
}

.navbar-brand {
  cursor: pointer !important;
}
</style>
